// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___QZpda","container_1":"container_1___3iYKr","container_2":"container_2___2Rjrj"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/repair/styles.module.scss
// module id = 899
// module chunks = 0